export default {
    blackList_00001: "黑名单列表",
    blackList_00002: "请输入内容",
    blackList_00003: "加入黑名单后，用户的微信号、手机号以及相同手机号对应的其他微信号，都不能在场站进行充电",
    blackList_00004: "理由",
    blackList_00005: "请输入将用户加入黑名单原因，最多20字",
}